import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

import { USER_SEARCH } from "MVVM/GraphQL/userSearch";

const UserSearchViewModel = () => {
  const [userSearchQueryRaw, { data, error, loading }] =
    useLazyQuery(USER_SEARCH);
  const userSearchQuery = useCallback(userSearchQueryRaw, []);

  return {
    data,
    error,
    loading,
    userSearchQuery,
  };
};

export { UserSearchViewModel };
